
@import "../../theme/global";
.center {
  text-align: center;
  padding: 1rem 1.5rem;

  lar-button {
    margin-bottom: 1.5rem;
    box-shadow:
      0 2px 8px -2px rgba(0, 0, 0, 0.12),
      0 4px 16px -4px rgba(0, 0, 0, 0.08);
  }

  lar-slider {
    margin: 0 auto;
    max-width: 100%;
  }
}